export const generateId = (prefix = 'id') => {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

export const formatCurrency = (amount, short = false) => {
  if (amount === 0) return '0 kr';
  if (short && amount >= 1000000) {
    return `${(amount / 1000000).toFixed(1)}M kr`;
  }
  if (short && amount >= 1000) {
    return `${(amount / 1000).toFixed(0)}k kr`;
  }
  return new Intl.NumberFormat('nb-NO', { style: 'currency', currency: 'NOK', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount);
};

export const formatDate = (date, includeTime = false) => {
  if (!date) return '';
  const dateObj = new Date(date);
  if (includeTime) {
    return new Intl.DateTimeFormat('nb-NO', {
      year: 'numeric', month: 'short', day: 'numeric',
      hour: '2-digit', minute: '2-digit'
    }).format(dateObj);
  }
  return new Intl.DateTimeFormat('nb-NO', { year: 'numeric', month: 'short', day: 'numeric' }).format(dateObj);
};

export const getInitials = (name) => {
  return name
    .split(' ')
    .map(word => word.charAt(0).toUpperCase())
    .join('')
    .slice(0, 2);
};

export const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) return text;
  return text.substr(0, maxLength) + '...';
};

export const calculateDaysUntil = (date) => {
  const today = new Date();
  const targetDate = new Date(date);
  const diffTime = targetDate - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

export const getStatusColor = (status, type = 'deal') => {
  if (type === 'deal') {
    switch (status) {
      case 'Åpen': return 'bg-blue-100 text-blue-800';
      case 'Vunnet': return 'bg-green-100 text-green-800';
      case 'Tapt': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  }
  if (type === 'project') {
    switch (status) {
      case 'Aktiv': return 'bg-green-100 text-green-800';
      case 'Planlagt': return 'bg-blue-100 text-blue-800';
      case 'Pause': return 'bg-yellow-100 text-yellow-800';
      case 'Tapt': return 'bg-red-100 text-red-800';
      case 'Vunnet': return 'bg-purple-100 text-purple-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  }
  return 'bg-gray-100 text-gray-800';
};

export const getActivityColor = (type) => {
  switch (type) {
    case 'Møte': return { bg: 'bg-indigo-50', text: 'text-indigo-700', border: 'border-indigo-100', icon: 'bg-indigo-500', dot: 'bg-indigo-500' };
    case 'Samtale': return { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-100', icon: 'bg-emerald-500', dot: 'bg-emerald-500' };
    case 'Oppgave': return { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-100', icon: 'bg-amber-500', dot: 'bg-amber-500' };
    case 'E-post': return { bg: 'bg-sky-50', text: 'text-sky-700', border: 'border-sky-100', icon: 'bg-sky-500', dot: 'bg-sky-500' };
    case 'Online møte': return { bg: 'bg-purple-50', text: 'text-purple-700', border: 'border-purple-100', icon: 'bg-purple-500', dot: 'bg-purple-500' };
    default: return { bg: 'bg-slate-50', text: 'text-slate-700', border: 'border-slate-100', icon: 'bg-slate-500', dot: 'bg-slate-500' };
  }
};

// Helper for Theme Customization
export const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? `${parseInt(result[1], 16)} ${parseInt(result[2], 16)} ${parseInt(result[3], 16)}` : '0 0 0';
};